/**
 * @generated SignedSource<<06a57a03cdcdf9a686c96e9649ecdcaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type UnifiedAiPostSortField = "CREATED_AT" | "LAST_REPLY_AT" | "LIKE_COUNT" | "UPDATED_AT" | "VIEW_COUNT" | "%future added value";
export type UnifiedAiPostType = "ARTICLE" | "QUESTION" | "%future added value";
export type UnifiedSortDirection = "ASC" | "DESC" | "%future added value";
export type UnifiedAiPostSortOrder = {
  direction: UnifiedSortDirection;
  field: UnifiedAiPostSortField;
};
export type GetPostsQuery$variables = {
  after?: string | null | undefined;
  categoryId?: string | null | undefined;
  first?: number | null | undefined;
  isLocked?: boolean | null | undefined;
  isPinned?: boolean | null | undefined;
  maxLikes?: number | null | undefined;
  maxViews?: number | null | undefined;
  minLikes?: number | null | undefined;
  minViews?: number | null | undefined;
  sortOrders?: ReadonlyArray<UnifiedAiPostSortOrder> | null | undefined;
  type?: ReadonlyArray<UnifiedAiPostType> | null | undefined;
};
export type GetPostsQuery$data = {
  readonly unified: {
    readonly ai: {
      readonly getPosts: {
        readonly code?: string | null | undefined;
        readonly edges?: ReadonlyArray<{
          readonly cursor: string | null | undefined;
          readonly node: {
            readonly author: {
              readonly aaid: string;
              readonly created_at: string;
              readonly email_id: string | null | undefined;
              readonly id: string;
              readonly nickname: string | null | undefined;
              readonly org_id: string | null | undefined;
              readonly updated_at: string;
            } | null | undefined;
            readonly author_id: string;
            readonly category: {
              readonly created_at: string;
              readonly description: string | null | undefined;
              readonly href: string;
              readonly id: string;
              readonly is_active: boolean;
              readonly name: string;
              readonly order: number;
              readonly parent_id: string | null | undefined;
              readonly type: string;
              readonly updated_at: string;
            } | null | undefined;
            readonly category_id: string;
            readonly content: string;
            readonly created_at: string;
            readonly edit_history: ReadonlyArray<{
              readonly edit_reason: string | null | undefined;
              readonly edited_at: string;
              readonly editor: {
                readonly aaid: string;
                readonly created_at: string;
                readonly email_id: string | null | undefined;
                readonly id: string;
                readonly nickname: string | null | undefined;
                readonly org_id: string | null | undefined;
                readonly updated_at: string;
              } | null | undefined;
              readonly editor_id: string;
              readonly id: string;
              readonly post_id: string;
            } | null | undefined> | null | undefined;
            readonly id: string;
            readonly is_locked: boolean;
            readonly is_pinned: boolean;
            readonly like_ids: ReadonlyArray<string>;
            readonly responses: ReadonlyArray<{
              readonly author: {
                readonly aaid: string;
                readonly created_at: string;
                readonly email_id: string | null | undefined;
                readonly id: string;
                readonly nickname: string | null | undefined;
                readonly org_id: string | null | undefined;
                readonly updated_at: string;
              } | null | undefined;
              readonly author_id: string;
              readonly content: string;
              readonly created_at: string;
              readonly edited_at: string | null | undefined;
              readonly id: string;
              readonly is_edited: boolean;
              readonly is_solution: boolean;
              readonly is_spam: boolean;
              readonly like_ids: ReadonlyArray<string>;
              readonly order: number;
              readonly parent_responseid: string | null | undefined;
              readonly post_id: string;
              readonly updated_at: string;
            } | null | undefined> | null | undefined;
            readonly tags: ReadonlyArray<string>;
            readonly title: string;
            readonly type: string;
            readonly updated_at: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly extensions?: ReadonlyArray<{
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        }> | null | undefined;
        readonly identifier?: string | null | undefined;
        readonly message?: string | null | undefined;
        readonly pageInfo?: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean | null | undefined;
          readonly hasPreviousPage: boolean | null | undefined;
          readonly startCursor: string | null | undefined;
        };
        readonly totalCount?: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type GetPostsQuery = {
  response: GetPostsQuery$data;
  variables: GetPostsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLocked"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPinned"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxLikes"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxViews"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minLikes"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minViews"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortOrders"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v11 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "categoryId",
    "variableName": "categoryId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "isLocked",
    "variableName": "isLocked"
  },
  {
    "kind": "Variable",
    "name": "isPinned",
    "variableName": "isPinned"
  },
  {
    "kind": "Variable",
    "name": "maxLikes",
    "variableName": "maxLikes"
  },
  {
    "kind": "Variable",
    "name": "maxViews",
    "variableName": "maxViews"
  },
  {
    "kind": "Variable",
    "name": "minLikes",
    "variableName": "minLikes"
  },
  {
    "kind": "Variable",
    "name": "minViews",
    "variableName": "minViews"
  },
  {
    "kind": "Variable",
    "name": "sortOrders",
    "variableName": "sortOrders"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "author_id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "like_ids",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updated_at",
  "storageKey": null
},
v19 = [
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "aaid",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email_id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "org_id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nickname",
    "storageKey": null
  },
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "UnifiedAiAccount",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited_at",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "post_id",
  "storageKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedPageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPreviousPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedAiPostEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnifiedAiPost",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            (v13/*: any*/),
            (v14/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "category_id",
              "storageKey": null
            },
            (v15/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "is_pinned",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "is_locked",
              "storageKey": null
            },
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tags",
              "storageKey": null
            },
            (v20/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UnifiedAiCategory",
              "kind": "LinkedField",
              "name": "category",
              "plural": false,
              "selections": [
                (v12/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "href",
                  "storageKey": null
                },
                (v14/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                (v21/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "parent_id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "is_active",
                  "storageKey": null
                },
                (v17/*: any*/),
                (v18/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UnifiedAiResponse",
              "kind": "LinkedField",
              "name": "responses",
              "plural": true,
              "selections": [
                (v12/*: any*/),
                (v13/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "is_solution",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "is_edited",
                  "storageKey": null
                },
                (v22/*: any*/),
                (v21/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "is_spam",
                  "storageKey": null
                },
                (v17/*: any*/),
                (v18/*: any*/),
                (v23/*: any*/),
                (v15/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "parent_responseid",
                  "storageKey": null
                },
                (v16/*: any*/),
                (v20/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UnifiedAiEditHistory",
              "kind": "LinkedField",
              "name": "edit_history",
              "plural": true,
              "selections": [
                (v12/*: any*/),
                (v23/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "editor_id",
                  "storageKey": null
                },
                (v22/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "edit_reason",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnifiedAiAccount",
                  "kind": "LinkedField",
                  "name": "editor",
                  "plural": false,
                  "selections": (v19/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "type": "UnifiedAiPostsConnection",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedQueryErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetPostsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedAiQuery",
            "kind": "LinkedField",
            "name": "ai",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "getPosts",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "GetPostsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedAiQuery",
            "kind": "LinkedField",
            "name": "ai",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "getPosts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v25/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a553f3b6b2aaecaf91789a593a72b1a1",
    "id": null,
    "metadata": {},
    "name": "GetPostsQuery",
    "operationKind": "query",
    "text": "query GetPostsQuery(\n  $after: String\n  $first: Int\n  $type: [UnifiedAiPostType!]\n  $isPinned: Boolean\n  $isLocked: Boolean\n  $sortOrders: [UnifiedAiPostSortOrder!]\n  $categoryId: String\n  $minViews: Int\n  $maxViews: Int\n  $minLikes: Int\n  $maxLikes: Int\n) {\n  unified {\n    ai {\n      getPosts(after: $after, first: $first, type: $type, isPinned: $isPinned, isLocked: $isLocked, sortOrders: $sortOrders, categoryId: $categoryId, minViews: $minViews, maxViews: $maxViews, minLikes: $minLikes, maxLikes: $maxLikes) {\n        __typename\n        ... on UnifiedAiPostsConnection {\n          pageInfo {\n            hasPreviousPage\n            hasNextPage\n            startCursor\n            endCursor\n          }\n          edges {\n            cursor\n            node {\n              id\n              title\n              content\n              type\n              category_id\n              author_id\n              is_pinned\n              is_locked\n              like_ids\n              created_at\n              updated_at\n              tags\n              author {\n                id\n                aaid\n                email_id\n                org_id\n                nickname\n                created_at\n                updated_at\n              }\n              category {\n                id\n                name\n                href\n                type\n                description\n                order\n                parent_id\n                is_active\n                created_at\n                updated_at\n              }\n              responses {\n                id\n                content\n                is_solution\n                is_edited\n                edited_at\n                order\n                is_spam\n                created_at\n                updated_at\n                post_id\n                author_id\n                parent_responseid\n                like_ids\n                author {\n                  id\n                  aaid\n                  email_id\n                  org_id\n                  nickname\n                  created_at\n                  updated_at\n                }\n              }\n              edit_history {\n                id\n                post_id\n                editor_id\n                edited_at\n                edit_reason\n                editor {\n                  id\n                  aaid\n                  email_id\n                  org_id\n                  nickname\n                  created_at\n                  updated_at\n                }\n              }\n            }\n          }\n          totalCount\n        }\n        ... on UnifiedQueryError {\n          identifier\n          message\n          code\n          extensions {\n            statusCode\n            errorType\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb91420b7aa0b7dab83718296923a4f7";

export default node;
